export default __webpack_public_path__ + "static/media/brandsInactive.9c3e5097.svg";